import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as sessionActions from 'actions/sessionActions'
import { PhoneNumberUtil } from 'google-libphonenumber'
import { deleteSavedPhoneNumber, invalidPhone } from '../../actions/uiActions'
import LoginForm from 'components/forms/LoginForm'
import { Container, Row, Col } from 'reactstrap'
import './loginpage.css'
import logo from 'assets/img/logo_white.png'

class LoginPage extends Component {
  state = {
    phone: '',
    code: '',
    buttonText: 'Получить СМС с паролем',
  }

  phoneUtil = PhoneNumberUtil.getInstance()

  componentDidMount() {
    this.props.deleteSavedPhoneNumber()
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  onClick = event => {
    event.preventDefault()
    if (this.props.phone) {
      console.log(this.state)
      this.props.actions.sendCode(this.state.phone, this.state.code)
    } else {
      const modifiedPhone = this.validatePhone(this.state.phone)
      if (modifiedPhone) {
        this.setState({
          phone: modifiedPhone,
          buttonText: 'Подтвердить код',
        })
        this.props.actions.sendSMS(modifiedPhone)
      }
    }
  }

  validatePhone = phone => {
    if (phone === '') {
      this.props.invalidPhone('Пожалуйста введите номер')
      return false
    }

    let modifiedPhone = '+7' + phone

    try {
      const number = this.phoneUtil.parseAndKeepRawInput(modifiedPhone, 'RU')
      modifiedPhone = `${number.getCountryCode()}` + number.getNationalNumber()

      if (this.phoneUtil.isValidNumber(number)) {
        return modifiedPhone
      } else {
        this.props.invalidPhone('Неверно набран номер')
        return false
      }
    } catch (err) {
      this.props.invalidPhone('Неверно набран номер')
      return false
    }
  }

  render() {
    return this.props.jwt ? (
      <Redirect to="/" />
    ) : (
      <Container
        fluid
        className="d-flex justify-content-center flex-column h-100 login-page dark-blue"
      >
        <Row className="align-items-center justify-content-center">
          <Col md={{ size: 4 }}>
            <img className="login_logo" src={logo} alt="logo" />
          </Col>
        </Row>
        <Row className="align-items-center justify-content-center ">
          <Col md={{ size: 3 }}>
            <LoginForm
              phone={this.props.phone}
              onChange={this.onChange}
              onClick={this.onClick}
              err={this.props.err}
              buttonText={this.state.buttonText}
            />
          </Col>
        </Row>
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  status: state.session.userStatus,
  phone: state.ui.phone,
  jwt: state.session.jwt,
  err: state.ui.err,
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(sessionActions, dispatch),
  deleteSavedPhoneNumber: () => dispatch(deleteSavedPhoneNumber()),
  invalidPhone: msg => dispatch(invalidPhone(msg)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)



// WEBPACK FOOTER //
// ./src/components/login/LoginPage.js